"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eql = exports.eqlObj = exports.eqlArray = void 0;
const eqlArray = (arrLeft, arrRight) => arrLeft.reduce((s, e, i) => s && (0, exports.eql)(e, arrRight[i]), true);
exports.eqlArray = eqlArray;
const eqlObj = (objLeft, objRight) => Object.keys(objLeft).reduce((s, e) => s && (0, exports.eql)(objLeft[e], objRight[e]), true);
exports.eqlObj = eqlObj;
const eql = (objLeft, objRight) => {
    if (typeof objLeft !== typeof objRight)
        return false;
    if (typeof objLeft === typeof objRight && typeof objLeft !== "object")
        return objLeft === objRight;
    if (objLeft instanceof Array && objRight instanceof Array)
        return (objLeft.length === objRight.length ? (0, exports.eqlArray)(objLeft, objRight) : false);
    return (0, exports.eqlObj)(objLeft, objRight);
};
exports.eql = eql;
//# sourceMappingURL=eql.js.map